
import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import Layout from '../Home'
import SymptomForm from '../../components/SymptomForm'


@inject('Symptoms')
@inject('DoctorTypes')
@observer
class EditDepartment extends Component {
  state = {
    hasSubmitted: false,
    data: {},
    doctorTypes: [],
  }

  async componentDidMount() {
    const { Symptoms, DoctorTypes, match: { params } } = this.props
    const data = await Symptoms.getSymptomById(params.symptomId)
    const doctorTypes = await DoctorTypes.fetchDoctorTypes()
    this.setState({ data, doctorTypes })
  }

  handleSubmit = async (values) => {
    const { Symptoms, history, match: { params } } = this.props
    await Symptoms.updateSymptom(values, params.symptomId)
    history.goBack()
  }

  render() {
    const { hasSubmitted, data, doctorTypes } = this.state

    return (
      <Layout
        {...this.props}
        render={(props) => (
          <SymptomForm
            onSubmit={this.handleSubmit}
            hasSubmitted={hasSubmitted}
            data={data}
            doctorTypes={doctorTypes}
            title="Edit Symptom"
            {...props}
            style={{ width: '100%' }}
          />
        )}
      />
    )
  }
}

EditDepartment.propTypes = {
}

EditDepartment.defaultProps = {
}

export default EditDepartment
